import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María Fernanda',
    text: 'Nunca pensé que hacer mis propias velas sería tan relajante. El curso explica todo tan claro que desde el primer intento logré resultados hermosos. ¡Ahora toda mi familia quiere que les regale mis creaciones!',
    role: 'Alumna'
  }, {
    name: 'Laura Gómez',
    text: 'Empecé esto como un hobby para desconectar del trabajo, y ahora estoy vendiendo mis jabones por Instagram. La calidad de lo que aprendes aquí es premium. Totalmente recomendado.',
    role: 'Emprendedora'
  }, {
    name: 'Carmen R.',
    text: 'Me encanta que todo sea tan natural. Las recetas son fáciles de seguir y los tips de presentación le dan ese toque profesional que buscaba. Es una inversión que vale cada centavo.',
    role: 'Amante de lo natural'
  }];
  return <section className="py-24 bg-artisanal-cream relative overflow-hidden" data-id="element-181">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-artisanal-beige rounded-full mix-blend-multiply filter blur-3xl opacity-70 transform -translate-x-1/2 -translate-y-1/2" data-id="element-182"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-artisanal-sage/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70 transform translate-x-1/3 translate-y-1/3" data-id="element-183"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-185">
          <h2 className="font-serif text-3xl md:text-4xl text-artisanal-brown font-bold mb-4" data-id="element-186">
            Historias de transformación
          </h2>
          <p className="font-sans text-lg text-artisanal-brown/70" data-id="element-187">
            Mujeres que ya están creando con sus manos.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-188">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-3xl shadow-sm relative" data-id="element-189">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-artisanal-beige opacity-50" data-id="element-190" />
              <p className="font-sans text-artisanal-brown/80 italic mb-8 relative z-10 leading-relaxed" data-id="element-191">
                "{testimonial.text}"
              </p>
              <div className="flex items-center" data-id="element-192">
                <div className="w-12 h-12 bg-artisanal-terracotta/20 rounded-full flex items-center justify-center text-artisanal-terracotta font-serif font-bold text-xl mr-4" data-id="element-193">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-194">
                  <h4 className="font-serif font-bold text-artisanal-brown" data-id="element-195">
                    {testimonial.name}
                  </h4>
                  <span className="font-sans text-sm text-artisanal-sage" data-id="element-196">
                    {testimonial.role}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}